import { render, staticRenderFns } from "./WikiScreenshotScanner.vue?vue&type=template&id=1e8d9c48"
import script from "./WikiScreenshotScanner.vue?vue&type=script&lang=ts"
export * from "./WikiScreenshotScanner.vue?vue&type=script&lang=ts"
import style0 from "./WikiScreenshotScanner.vue?vue&type=style&index=0&id=1e8d9c48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports